export enum CompanyTypeEnum {
  Business = 1,
  School = 2,
  Section = 3
}
